import { BookOpenIcon } from '@heroicons/react/24/outline';

import { Logo } from '@/components/Logo';
import Footer from '@/renderer/Footer';
import Header from '@/renderer/Header';
import { usePageContext } from '@/renderer/utils/usePageContext';
import Podcasts from '../index/components/Podcasts';
import { SubstackIcon, XIcon, YouTubeIcon } from './logos/SocialIcons';
// import srcBettingTalk from '../oauth/authorize/components/bettingtalk.png';

export default AboutPage;

export function About() {
  const {
    config: { title },
  } = usePageContext();

  return (
    <div className="flex h-40 min-h-[stretch] flex-1 grow flex-col justify-between overflow-hidden">
      <Header title="Who is RAS?" Icon={BookOpenIcon} className="py-2 sm:hidden" />
      <div className="overflow-auto">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="relative mx-auto hidden max-w-2xl pt-20 pb-24 text-center sm:block">
            <Logo className="mx-auto mb-12 size-24" />
            <h1 className="font-bold text-3xl text-zinc-900 tracking-tight sm:text-4xl dark:text-zinc-200">
              {title}
            </h1>
            <h2 className="my-auto mt-10 inline-block max-w-xl text-center text-base text-zinc-900/70 sm:text-lg md:text-xl dark:text-zinc-200/70">
              A sports betting group that is globally recognized and respected for decades of
              success in both private betting and public releases of free and paid picks.
            </h2>
          </div>
        </div>
        <div className="relative mt-8 px-4 sm:mt-0 sm:px-6 lg:px-8">
          <div className="prose prose-sm prose-zinc dark:prose-invert mx-auto max-w-prose prose-a:font-semibold prose-a:text-emerald-500 prose-a:hover:text-emerald-600">
            <p>
              Established in 1996, Right Angle Sports (RAS) has grown from a one-man operation into
              a large team. The RAS handicapping service, provides both free and paid picks publicly
              and has achieved long-term success in the college basketball, college football and NFL
              markets with a 55.5% win rate across their last 2,500, 5,000, and 7,500 releases (as
              of May 2024).
            </p>
            <p>RAS prides itself on selling picks the right way by offering:</p>
            <ul>
              <li>accurate recordkeeping, verified by third party.</li>
              <li>plays graded against widely available and mature market lines.</li>
              <li>no unit inflation.</li>
              <li>subscriptions that can be refunded at any time.</li>
            </ul>
            <p>
              Founder Edward started by posting college football write-ups on Internet chat rooms,
              attracting a dedicated following. He expanded his reach by sending out free pick
              emails, eventually building a mailing list and launching RAS as a full-fledged
              service. To attract new clients, the first month was often offered for free, with
              full-season subscriptions costing less than $100 in the late 1990's and early 2000's.
              Edward primarily focused on west coast schools and would often visit college hoops
              scrimmages and exhibitions in an effort to get info that the rest of the market didn't
              have.
            </p>
            <p>
              In the mid-2000s, Mike-RAS joined the team, bringing his talent for sports betting
              analysis. Together, Edward and Mike expanded RAS's play volume and scope, covering
              conferences beyond the West Coast. By 2010, RAS dominated the college hoops totals
              market, causing sportsbooks to take notice.
            </p>
            <p>
              Since that time, no other public or private group influences the betting market when
              placing or releasing a bet on a consistent basis more than RAS.
            </p>
            <p>
              RAS continues to expand, and today has a core team of six originators who work
              alongside a dedicated team of researchers and modelers. As betting markets continue to
              get more competitive, RAS has been able to leverage their unmatched expertise and
              experience to adapt and evolve where needed to maintain edges.
            </p>
          </div>
          <div className="mt-8 ml-4 flex flex-col justify-center space-y-4 sm:mx-auto sm:ml-auto sm:max-w-lg sm:flex-row sm:space-x-8 sm:space-y-0">
            <div className="flex items-center space-x-2">
              <a
                href="https://twitter.com/raspicks"
                target="_blank"
                className="group flex flex-row items-center space-x-2 text-sm text-zinc-500 hover:text-zinc-400"
                rel="noreferrer"
              >
                <XIcon height={24} className="size-6 fill-zinc-500 group-hover:fill-zinc-400" />
                <span>X (Twitter)</span>
              </a>
            </div>
            <div className="flex items-center space-x-2">
              <a
                href="https://www.youtube.com/@raspicks"
                target="_blank"
                className="group flex flex-row items-center space-x-2 text-sm text-zinc-500 hover:text-zinc-400"
                rel="noreferrer"
              >
                <YouTubeIcon
                  height={24}
                  className="size-6 fill-zinc-500 group-hover:fill-zinc-400"
                />
                <span>YouTube</span>
              </a>
            </div>
            <div className="flex items-center space-x-2">
              <a
                href="https://raspicks.substack.com/"
                target="_blank"
                className="group flex flex-row items-center space-x-2 text-sm text-zinc-500 hover:text-zinc-400"
                rel="noreferrer"
              >
                <SubstackIcon
                  height={20}
                  className="size-5 fill-zinc-500 group-hover:fill-zinc-400"
                />
                <span>Substack</span>
              </a>
            </div>
          </div>
          {/* <div className="mt-8">
            <img src={srcBettingTalk} className="mx-auto w-36" />
          </div> */}
        </div>
        <Podcasts />
        <Footer />
      </div>
    </div>
  );
}

// Main component
function AboutPage() {
  return <About />;
}
